import { render, staticRenderFns } from "./not-found-page.vue?vue&type=template&id=3ebdff6e"
import script from "./not-found-page.vue?vue&type=script&lang=js"
export * from "./not-found-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports